import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewsComponent } from './news.component';
import { NewsDetailComponent } from './news-detail/news-detail.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { NewsFormComponent } from './news-form/news-form.component';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:NewsComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
  {path:'new',component:NewsFormComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
  {path:'edit',component:NewsFormComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
  {path:'detail',component:NewsDetailComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager','userClube']}},
]

  // o Administrador Khuzela faz CRUD 
  // o Utilizador Khuzela  só Lê e Actualiza- CRUD
  // o Manager do Clube faz CRUD
  // o Utilizador do Clube faz CRUD

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class NewsRoutingModule { }
